import { render, staticRenderFns } from "./vtable2.vue?vue&type=template&id=6ec38335&scoped=true&"
import script from "./vtable2.vue?vue&type=script&lang=js&"
export * from "./vtable2.vue?vue&type=script&lang=js&"
import style0 from "./vtable2.vue?vue&type=style&index=0&id=6ec38335&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec38335",
  null
  
)

export default component.exports